import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { backgroundColors, colors, extraLargeShadow, fadeIn, spacing, zIndex } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { MODAL_SIZES, MODAL_VARIANTS, ModalSize } from './Modal.constants';

export type ModalStyles = { [x: string]: FlattenSimpleInterpolation };

export const MODAL_STYLES = {
  [MODAL_SIZES.SMALL]: css`
    width: ${pxToRem(470)};
  `,
  [MODAL_SIZES.MEDIUM]: css`
    width: ${pxToRem(672)};
  `,
  [MODAL_SIZES.LARGE]: css`
    width: ${pxToRem(980)};
  `,
  [MODAL_SIZES.CLIB]: css`
    width: 80vw;
    height: 90vh;
  `,
  [MODAL_SIZES.QUICK_ACTIONS]: css`
    width: ${pxToRem(672)};
    top: 20%;
  `,
};

export const MODAL_FOOTER_STYLES = {
  [MODAL_SIZES.SMALL]: css`
    padding: ${spacing.plusQuarter} ${spacing.plusHalf} ${spacing.plusHalf};
  `,
  [MODAL_SIZES.MEDIUM]: css`
    padding: ${spacing.plusQuarter} ${spacing.plusHalf} ${spacing.plusHalf};
  `,
  [MODAL_SIZES.LARGE]: css`
    padding: ${spacing.plusQuarter} ${spacing.plusHalf} ${spacing.plusHalf};
  `,
  [MODAL_SIZES.CLIB]: css`
    padding: ${spacing.plusQuarter} ${spacing.plusHalf} ${spacing.plusHalf};
    border-top: solid ${spacing.single} ${colors.grey15};
  `,
};

export const MODAL_BODY_STYLES = {
  [MODAL_SIZES.SMALL]: css`
    padding: ${spacing.quarter} ${spacing.plusHalf};
  `,
  [MODAL_SIZES.MEDIUM]: css`
    padding: ${spacing.quarter} ${spacing.plusHalf};
  `,
  [MODAL_SIZES.LARGE]: css`
    padding: ${spacing.quarter} ${spacing.plusHalf};
  `,
  [MODAL_SIZES.CLIB]: css`
    display: flex;
    flex: 1 1 auto;
    padding: ${spacing.base} ${spacing.double};
    background: ${backgroundColors.backgroundSecondary};
  `,
};

export const MODAL_HEADER_STYLES = {
  [MODAL_VARIANTS.INNER_PAGE]: css`
    padding: ${spacing.base} ${spacing.base} 0 ${spacing.base};
  `,
  [MODAL_SIZES.CLIB]: css`
    border-bottom: solid ${spacing.single} ${colors.grey15};
  `,
};

export const ModalTitle = styled.div`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ModalOverlay = styled.div`
  inset: 0;
  position: fixed;
  z-index: ${zIndex.modalOverlay};
  background: ${colors.backgroundScreen};
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeIn} 300ms cubic-bezier(0, 0, 0.34, 0.95);

  @keyframes ${fadeIn} {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  } ;
`;

export const ModalContainer = styled.dialog<{ size: ModalSize }>`
  padding: 0;
  border: none;
  align-self: center;
  background: ${colors.white};
  border-radius: ${spacing.threeQuarter};
  display: flex;
  ${extraLargeShadow};
  flex-direction: column;
  overflow: visible;
  z-index: ${zIndex.modal};
  height: auto;
  max-height: calc(100vh - ${spacing.x8});
  ${({ size }) => MODAL_STYLES[size] || ''};
  animation: modalFadeIn 300ms cubic-bezier(0, 0, 0.34, 0.95);

  @keyframes modalFadeIn {
    0% {
      opacity: 0;
      transform: translateY(-16px);
      transform: scale(0.95);
    }

    100% {
      opacity: 1;
      transform: translateY(0);
      transform: scale(1);
    }
  } ;
`;

/**
 * Screen reader text adapted from http://web-accessibility.carnegiemuseums.org/code/dialogs
 */
export const ScreenReaderText = styled.div`
  position: absolute;

  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;

  clip: rect(0 0 0 0);
  overflow: hidden;
`;

export const FooterMessageContainer = styled.div`
  display: flex;
  align-items: center;
`;
